export default "__VITE_ASSET__xXZ9HzoR__"